import { get } from 'lodash';
import { locationChanged } from '../../../actions/one-app';
import {
  MODAL_TYPE_ADD_CATEGORIES,
  MODAL_TYPE_POST_EDITOR,
} from '@wix/communities-blog-client-common/dist/src/constants/modal-types';
import { NAV_BUTTON_VALUES, ONE_APP_MODALS } from '../constants';

const MODAL_TITLES = {
  [MODAL_TYPE_POST_EDITOR]: ({ action, t }) =>
    get(action, 'payload.props.post._id') ? t('one-app.edit-post-page-title') : t('one-app.create-post-page-title'),
  [MODAL_TYPE_ADD_CATEGORIES]: ({ t }) => t('one-app.categories-modal-title'),
};
const MODAL_RIGHT_NAV_BUTTONS = {
  [MODAL_TYPE_POST_EDITOR]: ({ t }) => [
    {
      label: t('one-app.post-editor-modal-right-button'),
      value: { id: NAV_BUTTON_VALUES.POST_EDITOR_MENU },
    },
  ],
  [MODAL_TYPE_ADD_CATEGORIES]: ({ t }) => [
    {
      label: t('one-app.categories-modal-right-button'),
      value: { id: NAV_BUTTON_VALUES.SAVE_CATEGORIES },
    },
  ],
};

export default function onShowModal({ action, t }) {
  return dispatch => {
    const { type } = action.payload;
    if (ONE_APP_MODALS.indexOf(type) === -1) {
      return;
    }

    dispatch(
      locationChanged({
        action: 'displayModal',
        title: MODAL_TITLES[type]({ action, t }),
        rightNavButtons: MODAL_RIGHT_NAV_BUTTONS[type]({ action, t }),
      }),
    );
  };
}
